import { defineComponent as _defineComponent } from 'vue'
import TimeList from "@/components/list/TimeList.vue";
import ApprovalChip from "../table/ApprovalChip.vue";
import {
  ApprovalShift,
  ApprovalShiftUser
} from "@/models/approval/ApprovalResponse";
import { DateTime } from "luxon";
import { DataTableHeader } from "vuetify";
import { AttendanceFlowDat } from "@/models/transaction/AttendanceFlowDat";

type Props = {
  dat: AttendanceFlowDat;
  shift: ApprovalShift;
  reasons: string[];
  approvals: ApprovalShiftUser[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AttendanceExpandItem',
  props: {
    dat: null,
    shift: null,
    reasons: null,
    approvals: null
  },
  setup(__props: any) {

const beforeHeader = [
  { text: "開始時間： ", value: "preStartTime" },
  { text: "終了時間： ", value: "preEndTime" },
  { text: "総休憩時間： ", value: "preBreakTime" },
  { text: "早朝休憩時間： ", value: "preMorningBreakTime" },
  { text: "深夜休憩時間： ", value: "preMidnightBreakTime" },
  { text: "OPE時間", value: "preOpeTime" }
] as const;

const afterHeader = [
  { text: "開始時間： ", value: "afterStartTime" },
  { text: "終了時間： ", value: "afterEndTime" },
  { text: "総休憩時間： ", value: "afterBreakTime" },
  { text: "早朝休憩時間： ", value: "afterMorningBreakTime" },
  { text: "深夜休憩時間： ", value: "afterMidnightBreakTime" },
  { text: "OPE時間", value: "afterOpeTime" }
] as const;

const shiftHeader = [
  { text: "開始時間： ", value: "startTime" },
  { text: "終了時間： ", value: "endTime" },
  { text: "総休憩時間： ", value: "breakTime" },
  { text: "早朝休憩時間： ", value: "morningBreakTime" },
  { text: "深夜休憩時間： ", value: "midnightBreakTime" },
  { text: "OPE時間", value: "opeTime" }
] as const;

const approvalHeaders: DataTableHeader[] = [
  { text: "承認日", value: "approvalDate", divider: true },
  { text: "承認ユーザ", value: "approvalUserName", divider: true },
  {
    text: "承認状態",
    value: "approvalFlag",
    divider: true,
    align: "center",
    sortable: false,
    width: 100
  }
];

const formatDate = (date: string) => {
  return DateTime.fromISO(date)
    .setLocale("ja")
    .toFormat("yyyy年MM月dd日(EEE) HH:mm:ss");
};



const displayStatus = (item: any) => {
  let val = "";
  if (item.aid != "" && item.aid != undefined) val = "勤務時間";
  if (item.oid != "" && item.oid != undefined) {
    if (val != "") val = val + ",";
    val = val + "残業";
  }
  if (item.sid != "" && item.sid != undefined) {
    if (val != "") val = val + ",";
    val = val + "シフト";
  }
  if (item.vid != "" && item.vid != undefined) {
    if (val != "") val = val + ",";
    val = val + "休暇";
  }
  if (item.eid != "" && item.eid != undefined) {
    if (val != "") val = val + ",";
    val = val + "早出";
  }
  if (val != "") val = "申請 : " + val + "申請";
  return val;
};

return { __sfc: true,beforeHeader, afterHeader, shiftHeader, approvalHeaders, formatDate, displayStatus, TimeList, ApprovalChip }
}

})